
import * as HttpService from "../../../../service/HttpService";


/**
 * 获取光伏的树 初始化
 */
export const getOrgInfo_photovoltaic = () => {
    return HttpService.post(HttpService.DOMAIN + "/newkngf/Photovoltaic/getOrgInfo");
}
/**
 * 获取光伏的树 第一次加载
 */
export const getTreeInfo_photovoltaic = (id,ceResClass,ceResTreeNo,ceResSortNo,devOfHasMeters) => {
    var userFlag=ceResTreeNo==="CONS_ENERGY_MGMT_TREE"?"1":ceResTreeNo==="DIST_OPS_MGMT_TREE"?"2":ceResTreeNo==="ELEC_PURCHASE_MGMT_TREE"?
        "4":ceResTreeNo==="PHOTOVOLTAIC_PLANT_TREE"?"5":"3";

    var data={"id":id,"ceResClass":ceResClass};
    return HttpService.post(HttpService.DOMAIN + "/newkngf/Photovoltaic/getSearchTreeInfos",data);
}


/**
 * 获取单位
 */
export const orgInfoList = (ceResTreeNo) => {
    var userFlag=ceResTreeNo==="CONS_ENERGY_MGMT_TREE"?"1":ceResTreeNo==="DIST_OPS_MGMT_TREE"?"2":ceResTreeNo==="ELEC_PURCHASE_MGMT_TREE"?
        "4":ceResTreeNo==="PHOTOVOLTAIC_PLANT_TREE"?"5":ceResTreeNo==="STORED_ENERGY_TREE"?"6":ceResTreeNo==="WIND_POWER_PLANT_TREE"?"10":"3";
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getOrgInfo?userFlag=" + userFlag);
}

/**
 * 获取单位（社区资源树用）
 */
export const orgInfoListDist = () => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getOrgInfoDist");
}

/**
 * 获取当前运营商下是否存在低压以及高压
 */
export const getIsHeightPressureByOrgNo = (userFlag) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getIsHeightPressureByOrgNo?userFlag="+userFlag);
}


/**
 * 获取资源树信息  isWhetherPlan: 是否是用能计划 里调用的树
 */
export const getResTreeInfoList = (id,ceResClass,ceResTreeNo,ceResSortNo,devOfHasMeters, current,isWhetherPlan) => {
    var userFlag=ceResTreeNo==="CONS_ENERGY_MGMT_TREE"?"1":ceResTreeNo==="DIST_OPS_MGMT_TREE"?"2":ceResTreeNo==="ELEC_PURCHASE_MGMT_TREE"?
        "4":ceResTreeNo==="PHOTOVOLTAIC_PLANT_TREE"?"5":ceResTreeNo==="STORED_ENERGY_TREE"?"6":(ceResTreeNo==="DLFHXQC" || ceResTreeNo==="DLFHXQCUSER")?"7":ceResTreeNo==="WIND_POWER_PLANT_TREE"?"10":"3";

    var data={"nodeId":id,"ceResClass":ceResClass,"ceResTreeNo":ceResTreeNo,"superSortNo":ceResSortNo,"isMeter":devOfHasMeters
        ,"userFlag":userFlag,pageNumber:current,pageSize:20,"whetherPlan":isWhetherPlan,};
    if(ceResTreeNo ==="DLFHXQC"){
        data = {
            ...data,
            onlyOrg:true,
        }
    }
    return HttpService.post(HttpService.DOMAIN + "/ceResource/getTreesInfo",data);
}

/**
 * 获取资源树信息
 */
export const getMaxCustomInfo = (id,ceResClass,ceResTreeNo,ceResSortNo) => {
    var data={"nodeId":id,"ceResClass":ceResClass,"ceResTreeNo":ceResTreeNo,"superSortNo":ceResSortNo}
    return HttpService.post(HttpService.DOMAIN + "/ceResource/maxCustomInfo",data);
}


/**
 * 获取资源上层节点Id list
 */
export const getUpTreeIdList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/getUpTreeIdListOnPost", params);
};


/**
 * 根据名称模糊搜索资源树信息
 */
export const getSearchNameList = (name,ceResTreeNo) => {
    let userFlag=ceResTreeNo==="CONS_ENERGY_MGMT_TREE"?"1":ceResTreeNo==="DIST_OPS_MGMT_TREE"?"2":ceResTreeNo==="ELEC_PURCHASE_MGMT_TREE"?
        "4":ceResTreeNo==="PHOTOVOLTAIC_PLANT_TREE"?"5":(ceResTreeNo==="DLFHXQC" || ceResTreeNo==="DLFHXQCUSER")?"7":"3";
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getSearchNameList?name="+name+"&userFlag="+userFlag);
}
